import ProteinAnnotationsView from 'molbio/proteins/ProteinAnnotationsView';

export default class ProteinAlignmentAnnotationsView extends ProteinAnnotationsView {
  constructor(options, ...args) {
    super(options, ...args);
    this.annotations = options.annotations;
    this.className = 'proteinAlignmentAnnotations';
  }

  getPolymerLength() {
    return this.tabstate.getPolymerLength();
  }

  contextMenuOptions() {
    return [];
  }

  shouldSyncToStore() {
    return false;
  }

  isAnnotationHovered(annotation) {
    return false;
  }

  isAnnotationSelected(annotation) {
    return false;
  }

  getProteinId() {
    return null;
  }

  getAnnotations() {
    return this.annotations;
  }

  getResiduesType() {
    return this.tabstate.getType();
  }

  clickAction(e, d) {
    this.tabstate.get('selection').setEndpoints(d.start(), d.end());
  }

  dblClickAction(e, d) {}
}
